<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <h4 qid="maintenance-create-pg-title">
      {{$t('maintenance.process_groups.create.title')}}
    </h4>

    <div class="card">
      <div class="card-body">
        <div class="form-centered">
          <b-alert v-if="error.length"
                   show
                   variant="danger"
                   qid="create-pg-error"
          >
            {{ error }}
          </b-alert>
          <b-form @submit="formSubmit" qid="create-pg-form">
            <div class="form-container">
              <b-form-group>
                <label qid="create-pg-name-label">
                  {{ $t('maintenance.process_groups.create.name_label') }}
                </label>
                <b-form-input
                  qid="create-pg-form-name"
                  type="text"
                  v-model="tpForm.name"
                  required
                  :maxLength="255"
                  :placeholder="$t('maintenance.process_groups.create.name_placeholder')"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="text-right">
              <b-button class="mt-3"
                        variant="secondary"
                        @click="goToList"
                        qid="create-pg-cancel-button"
              >
                {{ $t('maintenance.process_groups.create.cancel') }}
              </b-button>
              <b-button type="submit"
                        class="mt-3 ml-3"
                        variant="success"
                        :disabled="buttonDisabled"
                        qid="create-pg-submit-button"
                        v-if="isGranted(permissions.PROCESS_GROUP_CREATE)"
              >
                <span v-if="buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </span>
                {{ $t('maintenance.process_groups.create.submit') }}
              </b-button>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'CreateProcessGroup',
    data: function() {
      return {
        breadcrumbItems: [
          {
            text: this.$t('dashboard.title'),
            to: '/'
          },
          {
            text: this.$t('maintenance.title'),
            to: '/maintenance'
          },
          {
            text: this.$t('maintenance.process_groups.title'),
            to: '/maintenance/process-groups'
          },
          {
            text: this.$t('maintenance.process_groups.create.title'),
            active: true
          }
        ],
        tpForm: {
          name: '',
          client:'',
        },
        error: '',
        inputLink: '',
        buttonDisabled: false
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      }
    },
    methods: {
      goToList() {
        this.$router.push('/maintenance/process-groups')
      },
      formSubmit(evt) {
        this.buttonDisabled = true;
        let formData = new FormData();
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        formData.append("name", this.tpForm.name);
        formData.append("client", this.getClient.slug);

        // Post FormData object to third parties API
        piincHttp.post('/process-groups', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function(response) {
          self.$toastr('success', self.$t('maintenance.process_groups.create.success'))
          self.buttonDisabled = false;
          self.goToList();
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            // Print whole array of actual errors beside message
            self.error = self.error + '\n\n' + JSON.stringify(error.data.errors);
          }
        })
      },
    },
    components: {

    },
    created () {

    }
  }
</script>
